export const version = 'bodhi.js/transactions/2.10.0';
